import { defineStore } from 'pinia';
import AgentAvailabilityAPI from 'dashboard/api/agentAvailability';

// Agent availability — backed by /api/v1/accounts/:id/agent_availabilities.
// Per-agent weekly working slots + time-off. The external chatbot reads `all`
// (with computed available_now / next_available_at) for handover decisions.
// Route ids are the agent's user_id; the profile page uses the `me` endpoint.

const toViewModel = r => ({
  userId: r.user?.id,
  accountUserId: r.account_user_id,
  user: r.user,
  role: r.role,
  isHuman: r.is_human,
  timezone: r.timezone || 'UTC',
  weeklySchedule: r.weekly_schedule || [],
  timeOff: r.time_off || [],
  availableNow: r.available_now,
  nextAvailableAt: r.next_available_at,
});

const toPayload = form => ({
  timezone: form.timezone,
  weekly_schedule: form.weeklySchedule || [],
  time_off: form.timeOff || [],
});

export const useAgentAvailabilityStore = defineStore('agentAvailability', {
  state: () => ({
    all: [],
    me: null,
  }),
  getters: {
    list: state => state.all,
    forUser: state => userId => state.all.find(a => a.userId === userId),
  },
  actions: {
    async fetchAll() {
      const { data } = await AgentAvailabilityAPI.get();
      this.all = (data.payload || []).map(toViewModel);
      return this.all;
    },
    async fetchMe() {
      const { data } = await AgentAvailabilityAPI.getMe();
      this.me = toViewModel(data);
      return this.me;
    },
    async fetch(userId) {
      const { data } = await AgentAvailabilityAPI.show(userId);
      return toViewModel(data);
    },
    async update(userId, form) {
      const { data } = await AgentAvailabilityAPI.update(userId, toPayload(form));
      const vm = toViewModel(data);
      if (this.me && this.me.userId === userId) this.me = vm;
      this.all = this.all.map(a => (a.userId === userId ? vm : a));
      return vm;
    },
  },
});
